export const WINDOW_RESIZE = '@@viewport/WINDOW_RESIZE',
    WINDOW_SCROLL = '@@viewport/WINDOW_SCROLL',
    windowResize = () => ({type: WINDOW_RESIZE}),
    windowScroll = () => ({type: WINDOW_SCROLL});


// WEBPACK FOOTER //
// ./src/actions/viewport.js